module.exports = __webpack_public_path__ + "img/solution.addca7a3.svg";